export default __webpack_public_path__ + "static/add-39acfc3427b6e10af8450e56fbec4853.svg";